import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import './RecordsNotFound.scss';
import RecordsNotFoundImage from '@assets/images/records-not-found.svg';

interface RecordsNotFoundProps {
	recordsCount: number;
}

export const RecordsNotFound: FunctionComponent<RecordsNotFoundProps> = memo(({ recordsCount }) => {
	return (
		<div className="records-not-found">
			<img src={RecordsNotFoundImage} alt="Access Denied" className="records-not-found__image"></img>
			{recordsCount ? (
				<span className="records-not-found__header">
					Change your search criteria to get less than {recordsCount + 1} accounts
				</span>
			) : (
				<span className="records-not-found__header">{recordsCount} records found</span>
			)}
		</div>
	);
});
